import React from 'react'
import cn from 'classnames'

function ListItem({ className, children, value }) {
  return (
    <li className={cn('list-group-item flex justify-between items-center min-h-[48px]', className)} style={{ backgroundColor: 'transparent' }}>
      {children}
      {value && (
        <div className="truncate">
          <small className="font-mono">{value}</small>
        </div>
      )}
    </li>
  )
}

export default ListItem
